import { AxiosPromise } from 'axios';
import { api } from '../../../shared/api';
import { IPopup, IPopupsStore } from '../model/popup.types';
import { IGetPopups } from './popup.dto';

export const getPopups = (params: IGetPopups): AxiosPromise<IPopupsStore> => api.get('/popups', { params });

export const checkPopupViewed = (id: number): AxiosPromise<IPopup> => api.patch(`/popups/${id}/set-viewed`);